import { Scale, FileCheck, UserRound } from "lucide-react";
import { WHY_BROKER } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const ICONS = [Scale, FileCheck, UserRound];

export const WhyBroker = () => (
  <section className="bg-white py-16 lg:py-24" data-testid="why-broker">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-widest text-xmove-orange">Perché XMOVE</p>
        <h2 className="mt-3 max-w-4xl font-display text-4xl font-bold text-xmove-ink sm:text-5xl lg:text-6xl">
          Siamo dalla tua parte.
        </h2>
        <p className="mt-3 max-w-2xl text-base text-xmove-muted md:text-lg">
          Non ci interessa venderti un'auto specifica: ci interessa che tu faccia il miglior affare possibile.
        </p>
      </Reveal>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {WHY_BROKER.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={p.title} delay={i * 0.1} className="h-full">
              <div className="h-full rounded-2xl border border-xmove-ink/8 bg-xmove-cream p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lift">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-xmove-orange/12 text-xmove-orange">
                  <Icon size={22} />
                </span>
                <h3 className="mt-5 font-display text-xl font-bold text-xmove-ink">{p.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-xmove-muted">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
